/**
 * WebRTCClient
 */
namespace SmartVideo {
export class WebRTCClient implements IVidyoClient {
    private webRTCPlugin: WebRTCPlugin;
    private webRTCAdapter: WebRTCAdapter;
    private webRTCServer: any;
    private messages: VidyoClientMessages;
    private outEventCallbackObject: Function;
    private outEventCallbackMethods: any;
    private defaultOutEventCallbackMethod: any;
    private logCallback: any;
    private useCallbackWithPlugin: boolean;
    private config: any;
    private sessionManager: any;
    private isChrome: boolean;
    private isFireFox: boolean;
    private browser: string;

    constructor(isChrome: boolean, browser: string) {
        this.webRTCPlugin = null;
        this.outEventCallbackObject = null;
        this.defaultOutEventCallbackMethod = '';
        this.logCallback = null;
        this.useCallbackWithPlugin = true;
        this.outEventCallbackMethods = {};
        this.sessionManager = null;
        this.isChrome = isChrome;
        this.browser = browser;
        this.messages = new VidyoClientMessages();
        this.webRTCAdapter = new WebRTCAdapter(browser);

        switch (browser) {
            case 'Opera':
                this.isChrome = true;
                break;
            case 'Chrome':
                this.isChrome = true;
                break;
            case 'SmartVideoAgent':
                this.isChrome = true;
                break;
            case 'Firefox':
                this.isFireFox = true;
                break;
            default:
                break;
        }
    }

    isStarted() {
        let retVal = false;
        if (!this.webRTCPlugin) {
            this.log('WebRTCClient.isStarted() invoked without start!');
            return retVal;
        }
        /* DEBUG: retVal = true;*/
        try {
            retVal = this.webRTCPlugin.isStarted();
        } catch (e) {
            this.log('WebRTCClient.isStarted() threw an exception!');
            this.log(e);
            return retVal;
        }
        this.log('WebRTCClient.isStarted() called plug-in.');
        return retVal;
    }

    isLoaded() {
        if (!this.webRTCPlugin) {
            this.log('WebRTCClient.isLoaded() invoked without start');
            return false;
        }

        try {
            this.webRTCPlugin.isStarted();
        } catch (e) {
            this.log('WebRTCClient.isLoaded() threw an exception!');
            return false;
        }

        return true;
    }

    setConfig(config) {
        console.log ('Setting config in WebRTCClient');
        if (config && config.outEventCallbackObject) {
            this.outEventCallbackObject = config.outEventCallbackObject;
            console.log('WebRTCClient: Callback object set');
        }
        if (config && config.defaultOutEventCallbackMethod) {
            this.defaultOutEventCallbackMethod = config.defaultOutEventCallbackMethod;
            console.log('WebRTCClient: Default Callback object set');
        }
        if (config && config.logCallback) {
            this.logCallback = config.logCallback;
            console.log('WebRTCClient: Log Callback object set');
        }
        if (config && config.sessionManager) {
            this.sessionManager = config.sessionManager;
            console.log('WebRTCClient: Session Manager set');
        }
    }

    setDefaultOutEventCallbackMethod(defaultOutEventCallbackMethodArg) {
        this.defaultOutEventCallbackMethod = defaultOutEventCallbackMethodArg;
    }

    setOutEventCallbackObject(outEventCallbackObjectArg) {
        this.outEventCallbackObject = outEventCallbackObjectArg;
    }

    setLogCallback(logCallbackArg) {
        this.logCallback = logCallbackArg;
        console.log('WebRTCClient.setLogCallback called');
    }

    setSessionManager(sessionManagerArg) {
        this.sessionManager = sessionManagerArg;
    }

    setOutEventCallbackMethod(outEventType, callbackMethod) {
        this.outEventCallbackMethods[outEventType] = callbackMethod;
    }

    getWebRTCServer(sessionManager, callback) {
        const url = window.location.protocol + '//' + sessionManager + '/zincadmin/service/getinstance.htm';
        const webRTCServer = '';
        const request = new XMLHttpRequest();
        request.open('get', url, true);
        request.onload = () => {
            const response = JSON.parse(request.responseText);
            this.webRTCServer = response.ip;
            callback(this.webRTCServer);
        };
        request.onerror = () => {
            this.webRTCServer = 'null';
            this.log('Ajax call to get webRTCServer IP address failed in WebRTCClient::getWebRTCServer');
            callback('null');
        }
        request.send();
    }

    start(config?) {
        let retVal = true;
        const self = this;
        this.setConfig(config);
        if (!this.sessionManager) {
            this.log('WebRTCClient.start() invoked without sessionManager!');
            return false;
        }

        try {
            this.getWebRTCServer(this.sessionManager, function() {
                self.log('WebRTCClient.start(): getWebRtcServer: sessionManager = ' +
                 self.sessionManager + ' webrtcServer = ' + self.webRTCServer);
                if (self.webRTCPlugin === null) {
                    self.webRTCPlugin = new WebRTCPlugin(self.browser, self.messages, self.webRTCServer, self.webRTCAdapter);
                }
                self.dispatchOutEvent({type: 'OutEventLogicStarted'});
                self.webRTCPlugin.useCallbackForOutEvents = true;
                self.webRTCPlugin.outEventCallbackObject = self;
                self.webRTCPlugin.outEventCallbackMethod = 'dispatchOutEvent';
                retVal = self.webRTCPlugin.start();
            });
        } catch (e) {
            this.log('WebRTCClient.start() threw an exception!');
            this.log(e);
            return retVal;
        }
        if (retVal) {
            this.log('WebRTCClient.start() called plug-in with successful return.');
        } else {
            this.log('WebRTCClient.start() called plug-in with return of error!');
        }

        return retVal;
    }

    stop() {
        let retVal = false;
        if (!this.webRTCPlugin) {
            this.log('WebRTCClient.stop() invoked without start!');
            return retVal;
        }
        /* DEBUG: retVal = true;*/
        try {
            retVal = this.webRTCPlugin.stop();
        } catch (e) {
            this.log('WebRTCClient.stop() threw an exception!');
            this.log(e);
            return retVal;
        }
        if (retVal) {
            this.log('WebRTCClient.stop() called plug-in with successful return.');
        } else {
            this.log('WebRTCClient.stop() called plug-in with return of error!');
        }
        return retVal;
    }

    sendEvent(event) {
        let retVal = false;
        if (!this.webRTCPlugin) {
            this.log('WebRTCClient.sendEvent() invoked without start!');
            return retVal;
        }
        if (!event || typeof event !== 'object') {
            this.log('WebRTCClient.sendEvent() invoked without valid event object!');
            return retVal;
        }
        if (typeof event.length === 'number' && !(event.propertyIsEnumerable('length'))) {
            this.log('WebRTCClient.sendEvent() invoked without valid event object!');
            return retVal;
        }
        /* DEBUG: retVal = true;*/
        try {
            retVal = this.webRTCPlugin.sendEvent(event);
        } catch (e) {
            this.log('WebRTCClient.sendEvent() threw an exception!');
            this.log(e);
            return retVal;
        }
        if (retVal) {
            this.log('WebRTCClient.sendEvent() called plug-in with successful return.');
        } else {
            this.log('WebRTCClient.sendEvent() called plug-in with return of error!');
        }
        return retVal;
    }

    sendRequest(request, callback) {
        let retVal = 'Error';
        if (!this.webRTCPlugin) {
            this.log('WebRTCClient.sendRequest() invoked without start');
            return 'ErrorNoPlugin';
        }
        if (!request || typeof request !== 'object') {
            this.log('WebRTCClient.sendRequest() invoked without valid request object!');
            return 'ErrorInvalidRequest';
        }
        if (typeof request.length === 'number' && !(request.propertyIsEnumerable('length'))) {
            this.log('WebRTCClient.sendRequest() invoked without valid request object!');
            return 'ErrorInvalidRequest';
        }
        /* DEBUG: retVal = true;*/
        try {
            retVal = this.webRTCPlugin.sendRequest(request);
        } catch (e) {
            this.log('WebRTCClient.sendRequest() threw an exception!');
            this.log(e);
            return 'ErrorInvalidPlugin';
        }
        if (retVal === 'ErrorOk') {
            this.log('WebRTCClient.sendRequest() called plug-in with successful return.');
        } else {
            this.log('WebRTCClient.sendRequest() called plug-in with return of ' + retVal + '!');
        }

        if (callback) {
            callback(request);
        }
        return retVal;
    }

    dispatchOutEvent(event) {
        if (this.outEventCallbackObject) {
            if (event && this.outEventCallbackMethods[event.type]) {
                if (typeof this.outEventCallbackMethods[event.type] === 'function') {
                    // if method is of function type, just invoke it with default this
                    this.outEventCallbackMethods[event.type].call(this.outEventCallbackObject || this, event);
                } else {
                    // otherwise, assume method is of string type, invoke it with object as this
                    this.outEventCallbackObject[this.outEventCallbackMethods[event.type]](event);
                }
                this.log('dispatchOutEvent() invoked specific out event callback method.');
            } else if (this.defaultOutEventCallbackMethod) {
                if (typeof this.defaultOutEventCallbackMethod === 'function') {
                    // if method is of function type, just invoke it with default this
                    this.defaultOutEventCallbackMethod.call(this.outEventCallbackObject || this, event);
                } else {
                    // otherwise, assume method is of string type, invoke it with object as this
                    this.outEventCallbackObject[this.defaultOutEventCallbackMethod](event);
                }
                this.log('WebRTCClient.dispatchOutEvent() invoked default out event callback method.');
            }
        }
    }

    log(message) {
        if (this.logCallback) {
            this.logCallback(message);
        }
    }

    // Only here for inteface matching
    setProxy(proxy?) {
        return;
    }
}
}
